import { SaleTokenList } from '../data/SaleTokenList'
import { ChainId } from '@yetiswap/sdk'
import INFTSalesList from '../models/INFTSalesList'

export function getSaleToken(token?: INFTSalesList, chainId?: ChainId) {
  return token && token.saleToken ? token.saleToken : SaleTokenList[0][chainId ? chainId : ChainId.FUJI]
}

export function getWalletAddress(address: string | undefined) {
  let result = ''
  if (address) {
    const addressLength = address.length
    result = address.substr(0, 15) + '...' + address.substr(addressLength - 4, addressLength)
    result = result.toLowerCase()
  }
  return result
}
